import { ScrollTriggerClass } from './'
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

class OpeningAnimation {
  constructor(el) {
    this.dom = {el: el};
    this.dom.loading = document.querySelector('[data-js="loading"]');
    this.dom.loadingCopy = this.dom.loading.querySelector('[data-js="loading-copy"]');

    // this.dom.cover = document.querySelector('[data-js="opening-cover"]');
    this.dom.copy = this.dom.el.querySelector('[data-js="opening-copy"]');
    // this.dom.copyCover = this.dom.el.querySelector('[data-js="opening-copy-cover"]');
    this.dom.copyInner = this.dom.el.querySelector('[data-js="opening-copy-inner"]');

    this.dom.copySp = this.dom.el.querySelectorAll('[data-js="copy-sp"] path');
    this.dom.copyPc = this.dom.el.querySelectorAll('[data-js="copy-pc"] path');
    this.dom.copyEn = this.dom.el.querySelector('[ data-js="copy-en"]');

    this.dom.triggerClass = document.querySelectorAll('[data-trigger="stc"]');
    
    this.init();
  }
  
  init() {
    setTimeout(()=>{
      window.scroll({top: 0, behavior: 'instant'});
    }, 100)
    // this.scrollDisable(30);
    
    this.dom.loadingCopy.addEventListener('animationend', () => {
      this.dom.loading.dataset.state = 'finish';
      this.loadingAnimation();
    });
    // this.dom.loading.addEventListener('animationend', (e) => {
    //   this.loadingAnimation();
    // })
  }

  loadingAnimation() {
    gsap.to(this.dom.loading, {
      opacity: 0,
      ease: 'linear',
      duration: 1.8,
      delay: .6,
      onComplete: () => {
        this.dom.loading.remove();
        this.textFadeAnimation();
        this.triggerEvent();
      }
    })
  }

  textFadeAnimation() {
    const elms = (this.getWindowW() < 768) ? this.dom.copySp : this.dom.copyPc;
    const tl = gsap.timeline();
    [...elms].forEach((el, i) => {
      tl.to(el, {
        opacity: 1,
        ease: 'power1.in',
        duration: .9,
        // delay: .1,
      }, '<10%')
    })
    tl.to(this.dom.copyEn, {
      opacity: 1,
      translateY: 0,
      ease: 'power2.inOut',
      duration: 2.4,
      onComplete: () => {
        // this.openingStart();
      },
    }, '-=1.2')
  }

  scrollDisable(_time) {
    setTimeout(()=>{
      document.body.dataset.isScrolldisable = 'true';
    }, _time);
  }

  openingStart() {
    // setTimeout(()=>{
    // }, _time);
    this.dom.el.dataset.opening = 'start';

    if (this.getWindowW() < 768) {
      gsap.to(this.dom.el, {
        height: 240,
        ease: 'expo.inOut',
        duration: 2.5,
        // delay: .1,
        onStart: ()=>{},
      })
      gsap.to(this.dom.copy, {
        translateY: '37.5%',
        ease: 'expo.inOut',
        duration: 2.5,
        // delay: .1,
        onStart: ()=>{},
      })
      gsap.to(this.dom.cover, {
        // '--mask-start': ((240 / this.getWindowH()) * 100),
        // '--mask-end': ((240 / this.getWindowH()) * 100),
        '--mask-start': 90,
        '--mask-end': 100,
        height: 240,
        ease: 'expo.inOut',
        duration: 3.4,
        // delay: .3,
        onStart: ()=>{},
      }, '<-12.5%')
    } else {
      gsap.to(this.dom.copyCover, {
        '--mask-start': 19.8279648609,
        '--mask-end': 22.3279648609,
        ease: 'power2.inOut',
        duration: 2,
        delay: .6,
        onStart: ()=>{},
      })
      gsap.to(this.dom.copyInner, {
        width: '22.3279648609%',
        ease: 'power3.inOut',
        duration: 2.6,
        onStart: ()=>{},
      }, '<-12.5%')
    }

    this.triggerEvent();
  }

  triggerEvent() {
    if (this.dom.triggerClass) new ScrollTriggerClass(this.dom.triggerClass);
  }

  getWindowW() {
    return window.innerWidth;
  }

  getWindowH() {
    return window.outerHeight;
  }
}

export default OpeningAnimation